import FundAllocation from "../fundAllocation";
import fundInfo from "../funds";

export default class FundAllocationCalculation {
    public allocations: Array<FundAllocation>;
    public trusteeBankAccount: FundAllocation;
    public moneyFund: FundAllocation;
    public incomeFund: FundAllocation;
    public responsibleGrowthFund: FundAllocation;

    constructor(allocations: Array<FundAllocation>) {
        this.allocations = allocations;
        this.trusteeBankAccount = FundAllocationCalculation.getAllocationByFundId(allocations, fundInfo.trusteeBankAccount.id);
        this.moneyFund = FundAllocationCalculation.getAllocationByFundId(allocations, fundInfo.moneyFund.id);
        this.incomeFund = FundAllocationCalculation.getAllocationByFundId(allocations, fundInfo.incomeFund.id);
        this.responsibleGrowthFund = FundAllocationCalculation.getAllocationByFundId(allocations, fundInfo.responsibleGrowthFund.id);
    }

    private static getAllocationByFundId(allocations: Array<FundAllocation>, fundId: number): FundAllocation {
        return allocations.filter(a => a.fund.id == fundId)[0];
    }
}
